export const types = [
  // "domain",
  "bundles",
  "siteAndAppsIds",
  // "publishers",
  "deviceIfas",
  "ipAdresses",
];
